import { Fiat } from '@/common/domain/token/Fiat';

export interface FiatUi {
  value: number;
  currency: string;
  text: string;
}

export const fromFiat = (fiat: Fiat): FiatUi => ({
  value: fiat.value,
  currency: fiat.currency,
  text: toTextWithSpaces(fiat),
});

const toTextWithSpaces = (fiat: Fiat): string => {
  const parts = fiat.value.toFixed(2).toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${parts.join('.')} ${fiat.currency}`;
};

export const emptyFiatUi = (): FiatUi => ({
  value: 0,
  currency: '',
  text: '',
});
